import { isFuture } from 'date-fns'
import { t } from '@lingui/core/macro'
import { formatWithLocale, parseDateRange } from '@dolfin/utils/dates'

export const getFirstCharsFromFullName = (fullName: string) => {
  const [firstName, lastName] = fullName.split(' ')
  if (!lastName) {
    return `${firstName[0]}`
  }

  return `${firstName[0]}${lastName[0]}`
}

export const toDBName = (name: string) =>
  name
    .toLowerCase()
    .replace(/ /g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '')

export function addOrdinalSuffix(num: number) {
  const lastDigit = num % 10
  const lastTwoDigits = num % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return num + 'th'
  }

  switch (lastDigit) {
    case 1:
      return num + 'st'
    case 2:
      return num + 'nd'
    case 3:
      return num + 'rd'
    default:
      return num + 'th'
  }
}

export const formatRangeWithLocale = (activePeriodString: string) => {
  const { start, end } = parseDateRange(activePeriodString) || {}
  if (!start) return ''

  const formattedStart = formatWithLocale(start, { dateStyle: 'medium' })
  const formattedEnd = end
    ? formatWithLocale(end, { dateStyle: 'medium' })
    : undefined

  return end
    ? `${formattedStart}${end ? ' -> ' + formattedEnd : ''}`
    : `${
        isFuture(new Date(start)) ? t`Starting` : t`Started`
      } ${formattedStart}`
}
